import { date } from 'yup/lib/locale';

export const phoneNumberMask = [
  '(',
  /[0-9]/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const cnpjNumberMask = [
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '/',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
];

export const cpfNumberMask = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
];

export const dateMask = [
  /[0-9]/,
  /[0-9]/,
  '/',
  /[0-9]/,
  /[0-9]/,
  '/',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];

export const zipcodeMask = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];

export const creditCardMask = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  ' ',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  ' ',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  ' ',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];

export const creditCardExpirationMask = [/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/];

export const creditCardMonthMask = [/[0-9]/, /[0-9]/];

export const creditCardYearMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

export const creditCardCvcMask = [/[0-9]/, /[0-9]/, /[0-9]/];

export const onlyNumbersMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

/**
 * Máscara para nome do portador do cartão (apenas letras e espaços)
 * @param {string} value - Valor atual do campo
 * @returns {Array} - Máscara para react-text-mask
 */
export const creditCardHolderNameMask = (value) => {
  // Permite apenas letras, espaços e caracteres acentuados
  const mask = [];
  if (value) {
    for (let i = 0; i < value.length; i++) {
      mask.push(/[a-zA-ZÀ-ÿ\s]/);
    }
  }
  return mask;
};

/**
 * Função para criar máscara dinâmica de nome
 * Esta função será usada com createTextMaskInputElement
 */
export const createHolderNameMask = () => {
  return (value) => {
    // Retorna uma máscara que aceita letras, espaços e acentos
    // O react-text-mask não suporta bem máscaras dinâmicas de texto,
    // então vamos usar uma abordagem diferente no componente
    return [];
  };
};
